import React, { useState, useRef } from "react";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { Container, ContainerView, TitlePage } from "../../components/Container";
import {
  BlockInfoWallet,
  HeaderTableStake,
  Separation,
  StakingOrderContainer,
  TextAddress,
  TextItemDetail,
} from "./style";
import { LoadingOutlined } from "@ant-design/icons";
import { RecordNotFound } from "../../components/RecordNotFound";
import { useWindowSize } from "../../hook/useWindowSize";
import { StakeOrderItem } from "./components/StakeOrderItem";
import { ModalFilter } from "./components/ModalFilter";
import { useApp } from "../../contexts";

import { useNavigate } from "react-router-dom";
import {
  convertDataStake,
  convertHexBalanceToDecimal,
} from "../../utils/hepler";
import ModalConnectWallet from "./components/ModalConnectWallet";
import ModalDetailStake from "./components/ModalDetailStake";
import { Col } from "antd";
import FormButton from "../../components/FormCustom2/Button";
import StakeBalanceIcon from "./components/StakeBalanceIcon";
import AmountVisibleToggle from "../../components/AmountVisibleToggle";
import NumberFormat from "react-number-format";
import RedeemBalanceIcon from "./components/RedeemBalanceIcon";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../utils/Currency";
import { useMemo } from "react";
import StakeForVotingIcon from "./components/StakeForVotingIcon";
import ArrowLeftIcon from "../../components/Icons/ArrowLeftIcon";
import { useModalConfirm } from "../../components/ModalConfirm/useModalConfirm";

const Stake = () => {
  const navigate = useNavigate();
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const {
    addressConnected,
    web3Provider,
    masterContract,
    T,
    getCurrency,
    userWeb3Addresses,
    setLoading,
    user,
    connectAddress
  } = useApp();
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [stakes, setStakes] = useState([]);
  const [balanceSGT, setBalanceSGT] = useState(0);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [dataViewStakeDetail, setDataViewStakeDetail] = useState(null);
  const [isGettingBalance, setIsGettingBalance] = useState(false);
  const [amountVisible, setAmountVisible] = useState(false);
  const [totalRedeemVisible, setTotalRedeemVisible] = useState(false);
  const ModalConfirm = useModalConfirm();
  const checkStatusIntervalRef = useRef(null);

  useEffect(() => {
    const handleChangeAccount = () => {
      connectAddress(window?.ethereum?.selectedAddress);
    };
    web3Provider?.provider?.on("accountsChanged", handleChangeAccount);
    return () => {
      web3Provider?.provider?.removeListener(
        "accountsChanged",
        handleChangeAccount
      );
    }
  }, [web3Provider?.provider]);

  useEffect(() => {
    const is_disconnect_wallet = Cookies.get("is_disconnect_wallet");
    if (is_disconnect_wallet === "true" || !user?.id) return;
    if (window.ethereum && window.ethereum.selectedAddress) {
      connectAddress(window.ethereum.selectedAddress);
    } else {
      connectAddress(null);
    }
  }, [user?.id]);

  useEffect(() => {
    if (!addressConnected) return;
    if (!masterContract) return;
    if (!web3Provider) return;
    (async () => {
      try {
        setIsGettingBalance(true);
        const balance = await masterContract.sgtContract.balanceOf(
          addressConnected
        );
        const decimailsSGTContract =
          await masterContract.sgtContract.decimals();
        setBalanceSGT(
          convertHexBalanceToDecimal(balance, decimailsSGTContract)
        );
        setIsGettingBalance(false);
      } catch (error) {
        setIsGettingBalance(false);
      }
    })();
  }, [addressConnected, web3Provider, masterContract]);

  useEffect(() => {
    if (!masterContract) return;
    if (!web3Provider) return;
    if (!userWeb3Addresses) return;
    if (!masterContract.sgtStakingContract) return;
    const getStakes = async () => {
      try {
        setLoading(true);
        const promises = userWeb3Addresses.map((address) =>
          masterContract.sgtStakingContract.getStakesFromAddress(address).then(res => {
            return res?.map(item => {
              const stakeData = (convertDataStake(item));
              return ({
                ...stakeData,
                fromAddress: address,
                txid: (`${address}_${stakeData.id}`).toLocaleLowerCase()
              });
            });
          })
        );
        const results = await Promise.all(promises);
        const stakes = results.flatMap(item => item) ?? [];
        const stakeIndex = stakes.map(stake => ({id: stake.id, fromAddress: stake.fromAddress, txid: (`${stake.fromAddress}_${stake.id}`).toLocaleLowerCase()}));
        const promiseClaims = stakeIndex.map(item => {
          return masterContract.sgtStakingClaimContract.canClaim(item.txid).then(res => {
            return {
              ...item,
              claimable: res?.[1] ?? false,
              claimAmount: convertHexBalanceToDecimal(res[2].toString(), 8),
              hasClaimed: res?.[4] ?? false,
            };
          });
        });
  
        const resClaims = await Promise.all(promiseClaims);
        const stakesWithClaim = stakes.map(stake => {
          const claim = resClaims.find(item => item.txid === stake.txid);
          return {
            ...stake,
            claimable: claim?.claimable ?? false,
            claimAmount: claim?.claimAmount ?? 0,
            hasClaimed: claim?.hasClaimed ?? false,
          };
        });
        setStakes(stakesWithClaim);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getStakes();
  }, [userWeb3Addresses, web3Provider, masterContract]);

  const totalActiveStakeBalance = useMemo(() => {
    return stakes.reduce((total, stake) => {
      return total + Number(stake.amount ?? 0);
    }, 0);
  }, [stakes]);

  const totalRedeemBalance = useMemo(() => {
    return stakes.reduce((total, stake) => {
      return total + Number(stake.rewardClaimed ?? 0);
    }, 0);
  }, [stakes]);

  const onClickViewDetailItem = (item) => {
    setDataViewStakeDetail(item);
  };

  const onCloseViewDetailItem = () => {
    setDataViewStakeDetail(null);
  };

  const handleRedeem = async (item) => {
    try {
      const confirm = await ModalConfirm.confirm({
        title: T("Redeem confirmation"),
        message: <div>
          <div>{T("Your staked SGT will be sent to your wallet address.")}</div>
          <div className="text-[18px] lg:text-[24px] font-semibold mt-4">
            <span>{T("Amount")}:&nbsp;</span>
            <NumberFormat
              value={item.amount}
              displayType="text"
              thousandSeparator={thousandSeparatorByCurrency(
                getCurrency()
              )}
              decimalSeparator={decimalSeparatorByCurrency(
                getCurrency()
              )}
              decimalScale={8}
              suffix=" SGT"
            />
          </div>
        </div>
      })
      if (confirm) {
        const res = await masterContract.sgtStakingContract
          ?.connect(web3Provider.getSigner())
          ?.unstake(item?.id);
        console.log(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClaim = async (item) => {
    try {
      const confirm = await ModalConfirm.confirm({
        title: T("Claim confirmation"),
        message: <div>
          <div>{T("Your SGT interest amount will be sent to your wallet address.")}</div>
          <div className="text-[18px] lg:text-[24px] font-semibold mt-4">
            <span>{T("Amount")}:&nbsp;</span>
            <NumberFormat
              value={item.claimAmount}
              displayType="text"
              thousandSeparator={thousandSeparatorByCurrency(
                getCurrency()
              )}
              decimalSeparator={decimalSeparatorByCurrency(
                getCurrency()
              )}
              decimalScale={8}
              suffix=" SGT"
            />
          </div>
        </div>
      })
      if (confirm) {
        setLoading(true);
        const res = await masterContract.sgtStakingClaimContract
          ?.connect(web3Provider.getSigner())
          ?.claimTokens(item?.txid);
        console.log(res);
        setLoading(false);
        if (res) {
          const txHash = res?.hash;
          if (txHash) {
            if (checkStatusIntervalRef.current) {
              clearInterval(checkStatusIntervalRef.current);
            }
            checkStatusIntervalRef.current = setInterval(async () => {
              const resReceipt = await window.ethereum.request({
                "method": "eth_getTransactionReceipt",
                "params": [
                  txHash
                ],
              });
              if (resReceipt) {
                if (resReceipt.status === "0x1") {
                  clearInterval(checkStatusIntervalRef.current);
                  checkStatusIntervalRef.current = null;
                  const updatedStakes = stakes.map((stake) => {
                    if (stake.txid === item.txid) {
                      return {
                        ...stake,
                        hasClaimed: true,
                      };
                    }
                    return stake;
                  });
                  setStakes(updatedStakes);
                }
              }
            }, 5000);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    navigate(-1);
  }

  useEffect(() => {
    return () => {
      if (checkStatusIntervalRef.current) {
        clearInterval(checkStatusIntervalRef.current);
      }
    };
  }, []);

  return (
    <Container>
      <ContainerView>
        <TitlePage className="flex gap-1 items-center">
          <div className="text-[30px] lg:text-[42px] cursor-pointer" onClick={goBack}>
            <ArrowLeftIcon />
          </div>
          {T("Stake for voting")}
        </TitlePage>
        <div className="flex justify-between items-center lg:mt-[47px] mt-[26px] ">
          <div className="text-[16px] lg:text-[18px] font-semibold">
            {T("Staking information")}
          </div>
        </div>

        {stakes.length > 0 && (
          <div className="flex flex-col lg:flex-row gap-5 mt-[20px] lg:mt-[30px] items-stretch">
            <div className="border border-solid border-[#0000001A] bg-white px-5 py-3 flex flex-row items-center rounded-[15px] min-h-[100px]">
              <div className="flex items-center justify-center">
                <StakeBalanceIcon />
              </div>
              <div className="w-[1px] bg-[#00000066] h-[80px] mx-6"></div>
              <div className="flex flex-col gap-2 justify-center">
                <div className="font-semibold text-[18px]/[22px]">
                  {T("Active Stake Balance")}
                </div>
                <div>
                  <AmountVisibleToggle
                    className="text-[25px]"
                    height={34}
                    visible={amountVisible}
                    onVisibleChange={(value) => setAmountVisible(value)}
                  >
                    <NumberFormat
                      className="text-[25px]"
                      value={totalActiveStakeBalance}
                      displayType="text"
                      thousandSeparator={thousandSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalScale={8}
                      suffix=" SGT"
                    />
                  </AmountVisibleToggle>
                </div>
              </div>
            </div>

            <div className="border border-solid border-[#0000001A] bg-white px-5 py-3 flex flex-row items-center rounded-[15px] min-h-[100px]">
              <div className="flex items-center justify-center">
                <RedeemBalanceIcon />
              </div>
              <div className="w-[1px] bg-[#00000066] h-[80px] mx-6"></div>
              <div className="flex flex-col gap-2 justify-center">
                <div className="font-semibold text-[18px]/[22px]">
                  {T("Total Redeem Balance")}
                </div>
                <div>
                  <AmountVisibleToggle
                    className="text-[25px]"
                    height={34}
                    visible={totalRedeemVisible}
                    onVisibleChange={(value) => setTotalRedeemVisible(value)}
                  >
                    <NumberFormat
                      className="text-[25px]"
                      value={totalRedeemBalance}
                      displayType="text"
                      thousandSeparator={thousandSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalScale={8}
                      suffix=" SGT"
                    />
                  </AmountVisibleToggle>
                </div>
              </div>
            </div>
          </div>
        )}

        {addressConnected ? (
          <BlockInfoWallet className="mt-[20px] lg:mt-[30px] border border-solid border-[#0000001A]">
            <div className="flex flex-wrap items-center gap-x-[50px]">
              <div className="flex flex-nowrap items-center ">
                <TextItemDetail className="whitespace-nowrap !text-[#707070]">
                  {T("Wallet Address")}:
                </TextItemDetail>
                <TextAddress className="!font-bold ml-1 !text-[#707070]">
                  {addressConnected}
                </TextAddress>
              </div>
              <Separation className="hidden lg:block !text-[#707070]" />
              <div className="flex flex-nowrap items-center ">
                <TextItemDetail className="!text-[#707070]">
                  {T("Available SGT balance")}:
                </TextItemDetail>
                {isGettingBalance ? (
                  <LoadingOutlined />
                ) : (
                  <TextItemDetail className="!font-bold ml-1 !text-[#707070]">
                    <NumberFormat
                      value={Number(balanceSGT)}
                      displayType="text"
                      thousandSeparator={thousandSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalScale={8}
                      suffix=" SGT"
                    />
                  </TextItemDetail>
                )}
              </div>
            </div>
            <FormButton
              width={isMobile ? 300 : 120}
              className="primary2 mt-[25px] ml-[50%] lg:mt-0 translate-x-[-50%] lg:translate-x-0 lg:ml-0"
              onClick={() => setIsVisibleModal(true)}
            >
              {T("title.change")}
            </FormButton>
          </BlockInfoWallet>
        ) : (
          <div className="bg-[#F9A73333] px-[20px] py-5 rounded-[15px] mt-[20px] lg:mt-[30px]">
            <div className="flex flex-col gap-4 lg:flex-row lg:justify-between lg:items-center">
              <div className="flex items-center gap-4">
                <div className="grow-1 shrink-0">
                  <StakeForVotingIcon />
                </div>
                <div className="flex-col flex gap-1">
                  <div className="text-[20px] font-semibold">
                    {T("Having another wallet?")}
                  </div>
                  <div>
                    {T(
                      "If you use another wallet for staking, please connect it now to claim your rewards."
                    )}
                  </div>
                </div>
              </div>
              <button
                className="btn-gradient w-full lg:w-auto"
                onClick={() => setIsVisibleModal(true)}
              >
                {T("Connect Wallet")}
              </button>
            </div>
          </div>
        )}

        <div className="mt-[44px] lg:mt-[57px]">
          <div className="flex justify-between items-center">
            <div className="text-[16px] lg:text-[18px] font-semibold">{T("Staking Orders")}</div>
          </div>
          <div className="mt-[21px] lg:mt-[30px]">
            {!stakes.length ? (
              <div>
                <RecordNotFound />
              </div>
            ) : (
              <>
                <HeaderTableStake gap={20} className="hidden lg:flex h-[34px]">
                  <Col
                    span={6}
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                  >
                    {T("Staking address")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                    span={4}
                  >
                    {T("Amount")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                    span={5}
                  >
                    {T("Interest Amount")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                    span={3}
                  >
                    {T("Duration")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] justify-center"
                    span={3}
                  >
                    {T("Status")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] justify-center"
                    span={3}
                  >
                    {T("Action")}
                  </Col>
                </HeaderTableStake>
                <StakingOrderContainer>
                  {stakes?.map((stake, index) => (
                    <StakeOrderItem
                      onClick={onClickViewDetailItem}
                      onRedeem={handleRedeem}
                      onClaim={handleClaim}
                      item={stake}
                      key={index}
                      isborder={index === stakes.length - 1 ? "false" : "true"}
                    />
                  ))}
                </StakingOrderContainer>
              </>
            )}
          </div>
        </div>
      </ContainerView>
      {dataViewStakeDetail && (
        <ModalDetailStake
          onBack={onCloseViewDetailItem}
          onClose={onCloseViewDetailItem}
          data={dataViewStakeDetail}
        />
      )}
      {isVisibleModal && (
        <ModalConnectWallet onClose={() => setIsVisibleModal(false)} />
      )}
      {isOpenFilter && (
        <ModalFilter
          isVisible={isOpenFilter}
          onClose={() => setIsOpenFilter(false)}
        />
      )}
    </Container>
  );
};

export default Stake;
